import { RecruitmentSeasonConfig } from "../../types";

export const GEN8_CONFIG: RecruitmentSeasonConfig = {
  generation: 8,
  generationName: "Gen 8",
  title: "GEN 8 RECRUITMENT",
  themeColor: "google.green",
  status: "CLOSED", // Status: CLOSED / OPEN / UPCOMING
  closedDateText: "21:59 ngày 27/09/2026",
  formUrl: "https://forms.gle/Ch6UTpEVf9UkviGh9",
  fanpageUrl: "https://www.facebook.com/gdgoc.dut",
  contactEmail: "gdgoc.dut@gmail.com",
  notification: {
    badgeText: "CỔNG ỨNG TUYỂN ĐÃ ĐÓNG",
    headline: "Kỳ tuyển thành viên Gen 8 đã chính thức khép lại",
    subheadline:
      "GDGoC - Danang University of Science and Technology xin gửi lời cảm ơn chân thành đến tất cả các bạn sinh viên đã dành thời gian và sự quan tâm để ứng tuyển vào Thế hệ thứ 8.",
    notes: [
      "Kết quả Vòng Đơn (Application Result) sẽ được thông báo trực tiếp qua Email của từng ứng viên.",
      "Vui lòng theo dõi hộp thư đến (bao gồm cả thư mục Spam/Quảng cáo) để không bỏ lỡ thông tin lịch phỏng vấn.",
      "Bạn vẫn có thể xem lại mô tả công việc (JD) của 4 ban bên dưới để định hướng và chuẩn bị cho các kỳ tuyển dụng tiếp theo.",
    ],
    primaryActionLabel: "Theo dõi kết quả tại Fanpage",
    primaryActionUrl: "https://www.facebook.com/gdgoc.dut",
    secondaryActionLabel: "Liên hệ Ban Tuyển Dụng",
    secondaryActionUrl: "mailto:gdgoc.dut@gmail.com",
  },
};
